import { render } from "./ChatGroupPage.vue?vue&type=template&id=cdbbff88&ts=true"
import script from "./ChatGroupPage.vue?vue&type=script&lang=ts"
export * from "./ChatGroupPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__